'use strict';

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _util = require('../util');

var AbstractHistory = (function () {
  function AbstractHistory(_ref) {
    var onChange = _ref.onChange;

    _classCallCheck(this, AbstractHistory);

    this.onChange = onChange;
    this.currentPath = '/';
  }

  _createClass(AbstractHistory, [{
    key: 'start',
    value: function start() {
      this.onChange('/');
    }
  }, {
    key: 'stop',
    value: function stop() {
      // noop
    }
  }, {
    key: 'go',
    value: function go(path) {
      path = this.currentPath = this.formatPath(path);
      this.onChange(path);
    }
  }, {
    key: 'formatPath',
    value: function formatPath(path) {
      return path.charAt(0) === '/' ? path : (0, _util.resolvePath)(this.currentPath, path);
    }
  }]);

  return AbstractHistory;
})();

exports['default'] = AbstractHistory;
module.exports = exports['default'];